
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import { getDefaultImplPopulated } from "../field-utils";
import Config from "data/config";

const FieldListEditDebug = (props) => {

    const field = props?.field;
    const schema = useSelectFieldSchema(field?.name);
    const defaultImpl = getDefaultImplPopulated(field?.type, schema);
    const value = props?.value;
    const settings = props?.settings;
    
    if (!Config.Debug.useDebug) {
        return null;
    }
    
    return (
        <div>
            <details>
                <summary>Value</summary>
                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                    {JSON.stringify(value, null, 2)}
                </pre>
            </details>
            <details>
                <summary>Settings</summary>
                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                    {JSON.stringify(settings, null, 2)}
                </pre>
            </details>
            <details>
                <summary>DefaultImpl</summary>
                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                    {JSON.stringify(defaultImpl, null, 2)}
                </pre>
            </details>
            <details>
                <summary>Schema</summary>
                <pre style={{ fontSize: "9px", border: "1px solid #999999" }}>
                    {JSON.stringify(schema, null, 2)}
                </pre>
            </details>
            {/*<details>*/}
            {/*    <summary>CONTEXT</summary>*/}
            {/*    <pre style={{fontSize: '9px', border: '1px solid #999999'}}>*/}
            {/*        {JSON.stringify(listItemContextProps, null, 2)}*/}
            {/*    </pre>*/}
            {/*</details>*/}
        </div>
    );
};
export { FieldListEditDebug };
